function extractQA(root) {
    if (!root) return [];

    const all = Array.from(root.querySelectorAll('*'));
    const result = [];

    // 当前正在等待答案的 Q
    let currentPair = null;

    const qReg = /^\s*Q\d*\s*[:：]\s*(.+)$/i;
    const aReg = /^\s*A\d*\s*[:：]\s*(.+)$/i;

    all.forEach(el => {
      const rawText = el.textContent || '';
      const text = rawText.trim();
      if (!text) return;

      let m;

      // 匹配 Q / Q1: / Q2:
      m = text.match(qReg);
      if (m) {
        const question = m[1].trim();
        currentPair = { q: question, a: '' };
        result.push(currentPair);
        return;
      }

      // 匹配 A / A1: / A2:
      m = text.match(aReg);
      if (m && currentPair && !currentPair.a) {
        const answer = m[1].trim();
        currentPair.a = answer;
        // 如果不希望多个 A 跟同一个 Q，就把 currentPair 清掉
        currentPair = null;
        return;
      }
    });

    // 过滤掉没有 A 的
    return result.filter(item => item.q && item.a);
  }

  function buildFaqJsonLd(qaList) {
    if (!Array.isArray(qaList)) return null;

    // 只保留 q/a 都有内容的
    const cleaned = qaList
      .filter(item => item && item.q && item.a)
      .map(item => ({
        q: String(item.q).trim(),
        a: String(item.a).trim()
      }));

    if (cleaned.length === 0) return null;

    const data = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: cleaned.map(item => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a
        }
      }))
    };

    // 用 JSON.stringify 负责转义引号、特殊字符，安全省心
    return JSON.stringify(data);
  }

  function injectFaqJsonLd(qaList) {
    const json = buildFaqJsonLd(qaList);
    if (!json) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = json;

    // 默认插到 <head>；如果没有 head，也可以退而求其次 body
    (document.head || document.body).appendChild(script);
  }

document.addEventListener('DOMContentLoaded', () => {
    const articleDom = window.document.querySelector('.article-template-inner')

    if (articleDom) {
        const data = extractQA(articleDom)
        if (data) {
            injectFaqJsonLd(data);
        }
    }
});
  
